import angular from 'angular';
import { MembershipServiceModule } from '../membership/membership.service';
import { ApiVersionFactoryModule } from '@b2c/common/factories/apiVersion/apiVersion.factory';

export const AuthServiceModule = angular.module('acme.common.service.auth', [
  MembershipServiceModule,
  ApiVersionFactoryModule
])
.service('AuthService', [ '$http', '$q', 'MembershipService', 'ApiVersionFactory', function($http, $q, MembershipService, ApiVersionFactory) {

    return {

      api: {

        av_visitor: new ApiVersionFactory({
          url: '/v1/b2c/visitor',
          version: 'v2'
        }),

        av_logout: new ApiVersionFactory({
          url: '/v1/b2c/logout',
          version: 'v2'
        }),

        login: function(props) {

          var headers;

          if (props.token) {
            headers = {
              'x-b2c-tenant-id' : props.tenantId,
              'x-acme-token': props.token
            };
          }else{
            headers = {
              'x-b2c-tenant-id' : props.tenantId,
              'x-acme-email': props.email,
              'x-acme-password': props.password
            };
          }

          return $http({
            method: 'get',
            url: this.av_visitor.url + '/session',
            headers: headers
          });
        },

        logout: function() {
          return $http({
            method: 'get',
            url: this.av_logout.url
          });
        },

        recover: function(tenantId, email) {
          return $http({
            method: 'get',
            url: this.av_visitor.url + '/recoverPassword',
            headers: {
              'x-b2c-tenant-id' : tenantId,
              'x-acme-email': email
            }
          });
        },

        changePassword: function(props) {
          return $http({
            method: 'get',
            url: this.av_visitor.url + '/tokenLogin',
            headers: {
              'x-b2c-tenant-id' : props.tenantId,
              'x-acme-token': props.token,
              'x-acme-password' : props.password
            }
          });
        }

      },

      cookie: false,
      membership: false,
      isLoggedIn: false,

      init: function() {
        return true;
      },

      getCookie: function() {
        $.cookie.json = true;
        this.cookie = $.cookie('visitor');
      },

      logout: function() {
        MembershipService.killCookie();
        return $.removeCookie('visitor', { path: '/' });
      },

      login: function(props) {

        var self = this,
            q = $q.defer();

        this.getCookie();

        if (this.cookie && !props.clean) {
          q.resolve(this.cookie);
        }else{
          this.logout();
          this.api.login(props).then(function (response) {
            q.resolve(response);
            self.isLoggedIn = true;
            self.cookie = response.data.payload;
          }, function (response) {
            q.reject(response);
            self.isLoggedIn = false;
            self.cookie = false;
          });
        }

        return q.promise;

      },

      error: {
      },

      success: {
      }

    };

}]).name;